export default "/images/cb8d1d017b9c8fdbf4c839e3c0e1a3ac.avif";